import { motion } from "framer-motion";
import { Overline } from "./Reveal";

// Reusable page hero banner for inner pages
export default function PageHero({ overline, title, subtitle, image }) {
  return (
    <section className="relative pt-40 pb-20 md:pt-52 md:pb-28 overflow-hidden">
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover opacity-45 brightness-110" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a]/50 via-[#0a0a0a]/70 to-[#0a0a0a]" />
      </div>
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.22,1,0.36,1] }}>
          <Overline>{overline}</Overline>
          <h1 className="font-serif-lux mt-5 text-5xl md:text-7xl lg:text-[6rem] leading-[0.92] tracking-tight text-[#fafafa]">
            {title}
          </h1>
          {subtitle && <p className="mt-6 max-w-2xl text-base md:text-lg text-[#b8b8b8] leading-relaxed">{subtitle}</p>}
        </motion.div>
      </div>
    </section>
  );
}
